import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandlerThunk } from '../App/App.thunk';
import tagService from './Tag.service';
import { TagListResponse } from '../ControlPanel/TagControl/TagControl.type';
import { TagSyncPayload } from './Tag.type';

export const getTagListThunk = createAsyncThunk(
  'tag/getTagListThunk',
  async (params: {q?: string, [key: string]: any}, thunkAPI): Promise<TagListResponse> => {
    try {
      const { data } = await tagService.getList(params);
      return data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  }
)

export const syncTagsThunk = createAsyncThunk(
  'tag/syncTagThunk',
  async (params: TagSyncPayload, thunkAPI): Promise<void> => {
    try {
      return await tagService.sync(params);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  }
)
